module.exports = __webpack_public_path__ + "static/img/logo1.f5702544.jpg";